<div [style.width]="width">
  <div class="checkbox" *ngFor="let item of items; let i = index">
    <input
      type="checkbox"
      name="option-{{ i }}"
      id="option-{{ i }}"
      [attr.data-qa]="'filters-side-panel-' + i + 'star-rating-checkbox'"
      [(ngModel)]="item.isSelected"
      (change)="onRatingChangeRequested()"
      [attr.disabled]="disabled || null"
      [ngClass]="{ disabled: disabled }"
    />
    <label [attr.for]="'option-' + i" [ngClass]="{ disabled: disabled }">
      <span *ngIf="item.numberOfStars > 0; else notRated">
        <span
          class="star"
          [ngClass]="{ checked: item.isSelected }"
          *ngFor="let star of [].constructor(item.numberOfStars)"
        ></span>
      </span>
      <span class="items-count">{{ item.numberOfItems }}</span>
    </label>
  </div>
</div>

<ng-template #notRated>
  {{ notRatedText }}
</ng-template>
